<template>
  <v-app style="background: #f5f7fa; min-height: 100vh;">
    <vue-header></vue-header>
    <vue-footer></vue-footer>
    <v-main :style="$vuetify.breakpoint.xs ? 'padding:0px!important;margin-top: 100px;' : 'padding:0px!important;margin-top: 140px;'">
      <v-container fluid style="margin-bottom:150px;" :class="$vuetify.breakpoint.xs ? 'px-2 py-4' : 'px-8 py-8'">

        <!-- Main Profile Card -->
        <v-row justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-card style="border-radius: 16px; overflow: hidden;" elevation="4">
              <!-- Profile Header -->
              <div style="background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%); padding: 32px 24px; position: relative;">
                <div class="d-flex align-start flex-column flex-sm-row" style="gap: 20px;">
                  <!-- Avatar -->
                  <v-avatar :size="$vuetify.breakpoint.xs ? 80 : 100" style="border: 4px solid rgba(255,255,255,0.2); flex-shrink: 0;" class="mx-auto mx-sm-0">
                    <img v-if="user.avatar" :src="user.avatar" alt="avatar">
                    <v-icon v-else class="material-icons-round" :size="$vuetify.breakpoint.xs ? 50 : 60" color="white">account_circle</v-icon>
                  </v-avatar>

                  <!-- Name and Info -->
                  <div style="flex: 1; padding-top: 8px;" class="text-center text-sm-left">
                    <h2 class="white--text mb-2" :style="{ fontSize: $vuetify.breakpoint.xs ? '24px' : '32px', fontWeight: 600, lineHeight: 1.2 }">
                      {{ user.first_name }} {{ user.last_name }}
                    </h2>
                    <div class="mb-2" style="opacity: 0.9;">
                      <div class="white--text d-flex align-center justify-center justify-sm-start" :style="{ fontSize: $vuetify.breakpoint.xs ? '12px' : '14px' }">
                        <v-icon small class="material-icons-round mr-1" style="color: rgba(255,255,255,0.8);">email</v-icon>
                        {{ user.email }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Stats Cards Container -->
              <div :style="{ padding: $vuetify.breakpoint.xs ? '24px 16px' : '32px 40px' }">
                <!-- Payment Stats Section -->
                <div class="mb-4">
                  <h3 :style="{ color: '#2c3e50', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px', opacity: 0.7 }">
                    Payment Information
                  </h3>
                  <v-row dense>
                    <v-col cols="6" sm="4">
                      <div :style="{ background: '#f8fafc', borderLeft: '4px solid #3b82f6', padding: $vuetify.breakpoint.xs ? '16px 12px' : '24px', borderRadius: '12px', minHeight: $vuetify.breakpoint.xs ? '100px' : '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }">
                        <div :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '10px' : '12px', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }">Approved</div>
                        <div :style="{ color: '#1e293b', fontSize: $vuetify.breakpoint.xs ? '32px' : '40px', fontWeight: 700, lineHeight: 1 }">{{ user.payments_approved || 0 }}</div>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="4">
                      <div :style="{ background: '#f8fafc', borderLeft: '4px solid #f59e0b', padding: $vuetify.breakpoint.xs ? '16px 12px' : '24px', borderRadius: '12px', minHeight: $vuetify.breakpoint.xs ? '100px' : '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }">
                        <div :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '10px' : '12px', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }">Remaining</div>
                        <div :style="{ color: '#1e293b', fontSize: $vuetify.breakpoint.xs ? '32px' : '40px', fontWeight: 700, lineHeight: 1 }">{{ user.payments_remaining || 0 }}</div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div :style="{ background: '#f8fafc', borderLeft: '4px solid #10b981', padding: $vuetify.breakpoint.xs ? '16px 12px' : '24px', borderRadius: '12px', minHeight: $vuetify.breakpoint.xs ? '100px' : '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }">
                        <div :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '10px' : '12px', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }">Total Paid</div>
                        <div :style="{ color: '#1e293b', fontSize: $vuetify.breakpoint.xs ? '28px' : '36px', fontWeight: 700, lineHeight: 1 }">${{ calculateTotalPaid() }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Financial Details Section -->
                <div class="mb-4">
                  <h3 :style="{ color: '#2c3e50', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px', opacity: 0.7 }">
                    Financial Details
                  </h3>
                  <v-row dense>
                    <v-col cols="6" sm="6">
                      <div :style="{ background: '#ffffff', border: '1px solid #e2e8f0', padding: $vuetify.breakpoint.xs ? '16px 12px' : '24px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', minHeight: $vuetify.breakpoint.xs ? '100px' : '120px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }">
                        <div class="d-flex align-center justify-space-between mb-2">
                          <span :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '10px' : '13px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }">Monthly Budget</span>
                          <v-icon :small="!$vuetify.breakpoint.xs" x-small="$vuetify.breakpoint.xs" style="color: #3b82f6;" class="material-icons-round">payments</v-icon>
                        </div>
                        <div :style="{ color: '#1e293b', fontSize: $vuetify.breakpoint.xs ? '28px' : '36px', fontWeight: 700 }">${{ user.monthly_budget || 500 }}</div>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <div :style="{ background: '#ffffff', border: '1px solid #e2e8f0', padding: $vuetify.breakpoint.xs ? '16px 12px' : '24px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', minHeight: $vuetify.breakpoint.xs ? '100px' : '120px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }">
                        <div class="d-flex align-center justify-space-between mb-2">
                          <span :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '10px' : '13px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }">Referrals</span>
                          <v-icon :small="!$vuetify.breakpoint.xs" x-small="$vuetify.breakpoint.xs" style="color: #8b5cf6;" class="material-icons-round">group</v-icon>
                        </div>
                        <div :style="{ color: '#1e293b', fontSize: $vuetify.breakpoint.xs ? '28px' : '36px', fontWeight: 700 }">{{ referredLeads.length }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Credit & Income Section -->
                <div class="mb-4">
                  <h3 :style="{ color: '#2c3e50', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px', opacity: 0.7 }">
                    Credit & Income
                  </h3>
                  <v-row dense>
                    <v-col cols="6" sm="6">
                      <div :style="{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: $vuetify.breakpoint.xs ? '16px 12px' : '24px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)', minHeight: $vuetify.breakpoint.xs ? '100px' : '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }">
                        <div :style="{ color: 'rgba(255,255,255,0.9)', fontSize: $vuetify.breakpoint.xs ? '10px' : '12px', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }">Credit Score</div>
                        <div :style="{ color: '#ffffff', fontSize: $vuetify.breakpoint.xs ? '32px' : '40px', fontWeight: 700, lineHeight: 1 }">{{ user.credit || 'N/A' }}</div>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <div :style="{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', padding: $vuetify.breakpoint.xs ? '16px 12px' : '24px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(245, 87, 108, 0.3)', minHeight: $vuetify.breakpoint.xs ? '100px' : '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }">
                        <div :style="{ color: 'rgba(255,255,255,0.9)', fontSize: $vuetify.breakpoint.xs ? '10px' : '12px', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }">Annual Income</div>
                        <div :style="{ color: '#ffffff', fontSize: $vuetify.breakpoint.xs ? '28px' : '36px', fontWeight: 700, lineHeight: 1 }">${{ user.employment_income ? Number(user.employment_income).toLocaleString() : '0' }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Referral Stats Section -->
                <div class="mb-4">
                  <h3 :style="{ color: '#2c3e50', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px', opacity: 0.7 }">
                    Referral Statistics
                  </h3>
                  <v-row dense>
                    <v-col cols="3" sm="3">
                      <div
                        @click="toggleReferredList"
                        :style="{ background: '#f8fafc', border: '1px solid #e2e8f0', padding: $vuetify.breakpoint.xs ? '10px 4px' : '16px 12px', borderRadius: '8px', textAlign: 'center', cursor: 'pointer', transition: 'all 0.3s ease' }"
                        class="stat-card-hover"
                      >
                        <div :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '8px' : '11px', fontWeight: 600, marginBottom: $vuetify.breakpoint.xs ? '4px' : '8px', textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1.2 }">Total Referrals</div>
                        <div :style="{ color: '#1e293b', fontSize: $vuetify.breakpoint.xs ? '24px' : '36px', fontWeight: 700, lineHeight: 1 }">{{ referredLeads.length }}</div>
                      </div>
                    </v-col>
                    <v-col cols="3" sm="3">
                      <div
                        @click="toggleReferredList"
                        :style="{ background: '#f8fafc', border: '1px solid #e2e8f0', padding: $vuetify.breakpoint.xs ? '10px 4px' : '16px 12px', borderRadius: '8px', textAlign: 'center', cursor: 'pointer', transition: 'all 0.3s ease' }"
                        class="stat-card-hover"
                      >
                        <div :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '8px' : '11px', fontWeight: 600, marginBottom: $vuetify.breakpoint.xs ? '4px' : '8px', textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1.2 }">Approved</div>
                        <div :style="{ color: '#10b981', fontSize: $vuetify.breakpoint.xs ? '24px' : '36px', fontWeight: 700, lineHeight: 1 }">{{ approvedReferrals }}</div>
                      </div>
                    </v-col>
                    <v-col cols="3" sm="3">
                      <div
                        @click="toggleReferredList"
                        :style="{ background: '#f8fafc', border: '1px solid #e2e8f0', padding: $vuetify.breakpoint.xs ? '10px 4px' : '16px 12px', borderRadius: '8px', textAlign: 'center', cursor: 'pointer', transition: 'all 0.3s ease' }"
                        class="stat-card-hover"
                      >
                        <div :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '8px' : '11px', fontWeight: 600, marginBottom: $vuetify.breakpoint.xs ? '4px' : '8px', textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1.2 }">Pending</div>
                        <div :style="{ color: '#f59e0b', fontSize: $vuetify.breakpoint.xs ? '24px' : '36px', fontWeight: 700, lineHeight: 1 }">{{ pendingReferrals }}</div>
                      </div>
                    </v-col>
                    <v-col cols="3" sm="3">
                      <div
                        @click="toggleReferredList"
                        :style="{ background: '#f8fafc', border: '1px solid #e2e8f0', padding: $vuetify.breakpoint.xs ? '10px 4px' : '16px 12px', borderRadius: '8px', textAlign: 'center', cursor: 'pointer', transition: 'all 0.3s ease' }"
                        class="stat-card-hover"
                      >
                        <div :style="{ color: '#64748b', fontSize: $vuetify.breakpoint.xs ? '8px' : '11px', fontWeight: 600, marginBottom: $vuetify.breakpoint.xs ? '4px' : '8px', textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1.2 }">This Month</div>
                        <div :style="{ color: '#3b82f6', fontSize: $vuetify.breakpoint.xs ? '24px' : '36px', fontWeight: 700, lineHeight: 1 }">{{ thisMonthReferrals }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Referred Leads Modal -->
                <v-dialog v-model="showReferredList" max-width="500px" :fullscreen="$vuetify.breakpoint.xs">
                  <v-card class="referred-leads-modal">
                    <!-- Header -->
                    <div class="modal-header">
                      <div class="d-flex align-center">
                        <v-avatar color="white" size="40" class="mr-3">
                          <v-icon color="#7c3aed" class="material-icons-round">group</v-icon>
                        </v-avatar>
                        <div>
                          <div class="header-title">Your Referred Leads</div>
                          <div class="header-subtitle">Manage and track all your referrals</div>
                        </div>
                      </div>
                      <v-btn icon @click="toggleReferredList" color="white">
                        <v-icon class="material-icons-round">close</v-icon>
                      </v-btn>
                    </div>

                    <!-- Sort By -->
                    <div class="px-4 py-3" style="background: white;">
                      <v-select
                        v-model="sortBy"
                        :items="sortOptions"
                        label="SORT BY"
                        dense
                        outlined
                        hide-details
                        :style="{ fontSize: '14px' }"
                      ></v-select>
                    </div>

                    <!-- Leads List -->
                    <v-card-text class="pa-0" style="max-height: 60vh; overflow-y: auto;">
                      <div v-if="sortedReferredLeads.length === 0" class="text-center py-8">
                        <v-icon size="64" color="grey lighten-1" class="material-icons-round mb-3">person_off</v-icon>
                        <div style="color: #64748b; font-size: 16px;">No referred leads yet</div>
                      </div>
                      <div v-else>
                        <div
                          v-for="(lead, index) in sortedReferredLeads"
                          :key="lead.user_id"
                          class="lead-item"
                          :style="{ borderBottom: index < sortedReferredLeads.length - 1 ? '1px solid #e2e8f0' : 'none' }"
                        >
                          <!-- Name -->
                          <div class="lead-row">
                            <div class="lead-label">Name</div>
                            <div class="lead-value d-flex align-center">
                              <v-avatar
                                :color="getAvatarColor(lead.first_name + ' ' + lead.last_name)"
                                size="32"
                                class="mr-2"
                              >
                                <span style="color: white; font-size: 14px; font-weight: 600;">
                                  {{ getInitials(lead.first_name, lead.last_name) }}
                                </span>
                              </v-avatar>
                              <span style="font-weight: 500;">{{ lead.first_name }} {{ lead.last_name }}</span>
                            </div>
                          </div>

                          <!-- Email -->
                          <div class="lead-row">
                            <div class="lead-label"></div>
                            <div class="lead-value" style="font-size: 13px; color: #64748b;">
                              <v-icon size="16" class="material-icons-round mr-1" style="color: #64748b;">email</v-icon>
                              {{ lead.email }}
                            </div>
                          </div>

                          <!-- Phone -->
                          <div class="lead-row">
                            <div class="lead-label">Phone</div>
                            <div class="lead-value">
                              <v-icon size="16" class="material-icons-round mr-1" style="color: #64748b;">phone</v-icon>
                              {{ lead.phone_m || 'N/A' }}
                            </div>
                          </div>

                          <!-- Date Added -->
                          <div class="lead-row">
                            <div class="lead-label">Date Added</div>
                            <div class="lead-value">
                              <v-icon size="16" class="material-icons-round mr-1" style="color: #64748b;">calendar_today</v-icon>
                              {{ formatDate(lead.created_at) }}
                            </div>
                          </div>

                          <!-- Status -->
                          <div class="lead-row">
                            <div class="lead-label">Status</div>
                            <div class="lead-value">
                              <v-chip
                                :color="getStatusColor(lead.lead_status || 'pending')"
                                text-color="white"
                                small
                                class="font-weight-bold"
                              >
                                <v-icon left small class="material-icons-round">
                                  {{ getStatusIcon(lead.lead_status || 'pending') }}
                                </v-icon>
                                {{ (lead.lead_status || 'pending').toUpperCase() }}
                              </v-chip>
                            </div>
                          </div>

                          <!-- Source -->
                          <div class="lead-row">
                            <div class="lead-label">Source</div>
                            <div class="lead-value">
                              <v-chip
                                color="#2196F3"
                                text-color="white"
                                small
                              >
                                <v-icon left small class="material-icons-round">phone</v-icon>
                                Voice Agent
                              </v-chip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-dialog>

                <!-- Referral Link Section -->
                <div class="mb-4">
                  <h3 :style="{ color: '#2c3e50', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px', opacity: 0.7 }">
                    Your Referral Link
                  </h3>
                  <div :style="{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: $vuetify.breakpoint.xs ? '20px 16px' : '24px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)' }">
                    <div class="d-flex align-center mb-3">
                      <v-icon class="material-icons-round mr-2" style="color: white; font-size: 24px;">link</v-icon>
                      <span :style="{ color: 'white', fontSize: $vuetify.breakpoint.xs ? '14px' : '16px', fontWeight: 600 }">Share this link to refer others</span>
                    </div>
                    <div :style="{ background: 'rgba(255,255,255,0.15)', padding: '12px 16px', borderRadius: '8px', marginBottom: '12px', wordBreak: 'break-all' }">
                      <span :style="{ color: 'white', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px', fontWeight: 500 }">{{ referralLink }}</span>
                    </div>
                    <v-row dense>
                      <v-col cols="6">
                        <v-btn
                          block
                          color="white"
                          class="font-weight-600"
                          :style="{ borderRadius: '8px', textTransform: 'none', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px' }"
                          @click="copyReferralLink"
                        >
                          <v-icon left class="material-icons-round" :small="$vuetify.breakpoint.xs" x-small>content_copy</v-icon>
                          <span v-if="!$vuetify.breakpoint.xs">Copy Link</span>
                          <span v-else>Copy</span>
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn
                          block
                          color="white"
                          outlined
                          class="font-weight-600"
                          :style="{ borderRadius: '8px', textTransform: 'none', fontSize: $vuetify.breakpoint.xs ? '12px' : '14px', borderColor: 'white', color: 'white' }"
                          @click="shareReferralLink"
                        >
                          <v-icon left class="material-icons-round" :small="$vuetify.breakpoint.xs" x-small>share</v-icon>
                          Share
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Referred Leads Table (Optional - can be removed if not needed) -->
        <v-row v-if="referredLeads.length > 0" class="mt-4">
          <v-col cols="12">
            <v-card style="border-radius: 16px;" elevation="4">
              <v-card-title class="pa-6" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                <div class="d-flex align-center">
                  <v-avatar size="48" color="white" class="mr-3">
                    <span class="material-icons-round primary--text" style="font-size: 28px;">group</span>
                  </v-avatar>
                  <div>
                    <h2 class="text-h5 font-weight-bold white--text mb-0">Your Referred Leads</h2>
                    <p class="text-subtitle-2 white--text mb-0" style="opacity: 0.9;">Manage and track all your referrals</p>
                  </div>
                </div>
              </v-card-title>
              <v-card-text class="pa-0">
                <v-data-table
                  :headers="headers"
                  :items="referredLeads"
                  :items-per-page="10"
                  :loading="loading"
                  class="modern-table"
                >
                  <template v-slot:item.name="{ item }">
                    <div class="d-flex align-center py-3">
                      <v-avatar size="48" class="mr-4 elevation-2" :color="getAvatarColor(item.first_name)">
                        <span class="white--text text-h6 font-weight-bold">
                          {{ getInitials(item.first_name, item.last_name) }}
                        </span>
                      </v-avatar>
                      <div>
                        <div class="font-weight-bold black--text text-subtitle-1">{{ item.first_name }} {{ item.last_name }}</div>
                        <div class="text-caption grey--text text--darken-1">
                          <span class="material-icons-round" style="font-size: 14px; vertical-align: middle;">email</span>
                          {{ item.email }}
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:item.phone_m="{ item }">
                    <div class="d-flex align-center">
                      <span class="material-icons-round grey--text mr-2" style="font-size: 18px;">phone</span>
                      <span class="black--text font-weight-medium">{{ item.phone_m || 'N/A' }}</span>
                    </div>
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    <div class="d-flex align-center">
                      <span class="material-icons-round grey--text mr-2" style="font-size: 18px;">calendar_today</span>
                      <span class="black--text">{{ formatDate(item.created_at) }}</span>
                    </div>
                  </template>

                  <template v-slot:item.lead_status="{ item }">
                    <v-chip
                      :color="getStatusColor(item.lead_status)"
                      label
                      class="font-weight-bold px-4"
                      dark
                    >
                      <span class="material-icons-round mr-1" style="font-size: 16px;">
                        {{ getStatusIcon(item.lead_status) }}
                      </span>
                      {{ (item.lead_status || 'Pending').toUpperCase() }}
                    </v-chip>
                  </template>

                  <template v-slot:item.lead_source="{ item }">
                    <v-chip
                      :color="item.lead_source === 'Voice Agent' ? '#2196F3' : '#9C27B0'"
                      label
                      class="font-weight-bold px-4"
                      dark
                    >
                      <span class="material-icons-round mr-1" style="font-size: 16px;">
                        {{ item.lead_source === 'Voice Agent' ? 'phone' : 'chat' }}
                      </span>
                      {{ item.lead_source || 'Chat Agent' }}
                    </v-chip>
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center pa-12">
                      <v-avatar size="120" color="grey lighten-3" class="mb-6">
                        <span class="material-icons-round grey--text" style="font-size: 64px;">people_outline</span>
                      </v-avatar>
                      <h3 class="text-h5 font-weight-bold black--text mb-3">No referrals yet</h3>
                      <p class="text-subtitle-1 grey--text text--darken-1 mb-6">Start sharing your referral link to grow your network!</p>
                      <v-btn
                        color="blue"
                        large
                        @click="copyReferralLink"
                        class="white--text"
                        elevation="4"
                        style="border-radius: 12px;"
                      >
                        <span class="material-icons-round mr-2">content_copy</span>
                        Copy Referral Link
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- Success Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" top>
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import moment from 'moment';
import VueHeader from './Layout/Header.vue';
import VueFooter from './Layout/Footer.vue';

export default {
  name: 'LeadDashboard',
  components: {
    VueHeader,
    VueFooter
  },
  data() {
    return {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        avatar: '',
        payments_approved: 0,
        payments_remaining: 0,
        monthly_budget: 500,
        credit: '',
        employment_income: 0
      },
      referralLink: '',
      referredLeads: [],
      showReferredList: false,
      sortBy: 'newest',
      sortOptions: [
        { text: 'Newest First', value: 'newest' },
        { text: 'Oldest First', value: 'oldest' },
        { text: 'Name (A-Z)', value: 'name_asc' },
        { text: 'Name (Z-A)', value: 'name_desc' },
        { text: 'Status: Approved', value: 'approved' },
        { text: 'Status: Pending', value: 'pending' }
      ],
      loading: false,
      copying: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      headers: [
        { text: 'Name', value: 'name', sortable: false, width: '30%' },
        { text: 'Phone', value: 'phone_m', align: 'center', width: '20%' },
        { text: 'Date Added', value: 'created_at', align: 'center', sortable: true, width: '20%' },
        { text: 'Status', value: 'lead_status', align: 'center', width: '15%' },
        { text: 'Source', value: 'lead_source', align: 'center', width: '15%' }
      ]
    };
  },
  computed: {
    approvedCount() {
      return this.referredLeads.filter(lead => lead.lead_status === 'approved').length;
    },
    pendingCount() {
      return this.referredLeads.filter(lead => !lead.lead_status || lead.lead_status === 'pending').length;
    },
    thisMonthCount() {
      const now = moment();
      return this.referredLeads.filter(lead => {
        return moment(lead.created_at).isSame(now, 'month');
      }).length;
    },
    approvedReferrals() {
      return this.referredLeads.filter(lead => lead.lead_status === 'approved').length;
    },
    pendingReferrals() {
      return this.referredLeads.filter(lead => !lead.lead_status || lead.lead_status === 'pending').length;
    },
    thisMonthReferrals() {
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();

      return this.referredLeads.filter(lead => {
        const leadDate = new Date(lead.created_at);
        return leadDate.getMonth() === currentMonth && leadDate.getFullYear() === currentYear;
      }).length;
    },
    sortedReferredLeads() {
      let leads = [...this.referredLeads];

      switch(this.sortBy) {
        case 'newest':
          return leads.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        case 'oldest':
          return leads.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        case 'name_asc':
          return leads.sort((a, b) => {
            const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
            const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
            return nameA.localeCompare(nameB);
          });
        case 'name_desc':
          return leads.sort((a, b) => {
            const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
            const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
            return nameB.localeCompare(nameA);
          });
        case 'approved':
          return leads.filter(lead => lead.lead_status === 'approved');
        case 'pending':
          return leads.filter(lead => !lead.lead_status || lead.lead_status === 'pending');
        default:
          return leads;
      }
    }
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login');
      return;
    }
    this.loadUserData();
    this.getReferralLink();
    this.getReferredLeads();
  },
  methods: {
    async loadUserData() {
      try {
        const response = await axios.get('/api/user', {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1 || response.data) {
          const userData = response.data.user || response.data;
          this.user = {
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            email: userData.email || '',
            avatar: userData.avatar || '',
            payments_approved: userData.payments_approved || 0,
            payments_remaining: userData.payments_remaining || 0,
            monthly_budget: userData.monthly_budget || 500,
            credit: userData.credit || userData.credit_score_range || '',
            employment_income: userData.employment_income || userData.income || 0
          };
        }
      } catch (error) {
        console.error('Error loading user data:', error);
      }
    },
    calculateTotalPaid() {
      const paymentsApproved = this.user.payments_approved || 0;
      const monthlyBudget = this.user.monthly_budget || 500;
      const totalPaid = paymentsApproved * monthlyBudget;
      return totalPaid.toLocaleString();
    },
    async getReferralLink() {
      try {
        const response = await axios.get('/api/lead-referral/get-link', {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.referralLink = response.data.data.referral_link;
        } else {
          this.showSnackbar(response.data.message, 'error');
        }
      } catch (error) {
        console.error('Error getting referral link:', error);
        this.showSnackbar('Failed to load referral link', 'error');
      }
    },
    async getReferredLeads() {
      this.loading = true;
      try {
        const response = await axios.get('/api/lead-referral/referred-leads', {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.referredLeads = response.data.data;
        } else {
          this.showSnackbar(response.data.message, 'error');
        }
      } catch (error) {
        console.error('Error getting referred leads:', error);
        this.showSnackbar('Failed to load referred leads', 'error');
      } finally {
        this.loading = false;
      }
    },
    async copyReferralLink() {
      this.copying = true;
      try {
        await navigator.clipboard.writeText(this.referralLink);
        this.showSnackbar('Referral link copied to clipboard!', 'success');
      } catch (error) {
        console.error('Error copying to clipboard:', error);
        this.showSnackbar('Failed to copy link', 'error');
      } finally {
        this.copying = false;
      }
    },
    shareReferralLink() {
      if (navigator.share) {
        navigator.share({
          title: 'Join me on AutoSyncX!',
          text: 'Check out this amazing platform!',
          url: this.referralLink
        }).catch(err => console.log('Error sharing:', err));
      } else {
        this.copyReferralLink();
      }
    },
    formatDate(date) {
      return moment(date).format('MMM DD, YYYY');
    },
    getStatusColor(status) {
      const colors = {
        'approved': '#4CAF50',
        'pending': '#FF9800',
        'rejected': '#F44336'
      };
      return colors[status] || '#9E9E9E';
    },
    getStatusIcon(status) {
      const icons = {
        'approved': 'check_circle',
        'pending': 'schedule',
        'rejected': 'cancel'
      };
      return icons[status] || 'help';
    },
    getInitials(firstName, lastName) {
      const first = firstName ? firstName.charAt(0).toUpperCase() : '';
      const last = lastName ? lastName.charAt(0).toUpperCase() : '';
      return first + last;
    },
    getAvatarColor(name) {
      const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];
      const index = name ? name.charCodeAt(0) % colors.length : 0;
      return colors[index];
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    toggleReferredList() {
      if (this.referredLeads.length > 0) {
        this.showReferredList = !this.showReferredList;

        // Scroll to the list when opening
        if (this.showReferredList) {
          this.$nextTick(() => {
            const listElement = document.querySelector('.referred-leads-list');
            if (listElement) {
              listElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          });
        }
      } else {
        this.showSnackbar('No referred leads yet', 'info');
      }
    },
    showSnackbar(text, color = 'success') {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    }
  }
};
</script>

<style scoped>
.welcome-header {
  padding: 20px 0;
}

.stat-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  background: white;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0,0,0,0.15) !important;
}

.stat-card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
  background: #ffffff !important;
}

.stat-card-hover:active {
  transform: translateY(0);
}

.referred-leads-list {
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.referred-leads-modal {
  border-radius: 16px !important;
  overflow: hidden;
}

.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  color: white;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 400;
}

.lead-item {
  padding: 16px 20px;
  background: white;
  transition: background 0.2s ease;
}

.lead-item:hover {
  background: #f8fafc;
}

.lead-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.lead-row:last-child {
  margin-bottom: 0;
}

.lead-label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  min-width: 100px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.lead-value {
  font-size: 14px;
  color: #1e293b;
  flex: 1;
  display: flex;
  align-items: center;
}

.referral-card {
  border-radius: 20px !important;
  background: white;
  transition: all 0.3s ease;
}

.referral-input >>> .v-input__control {
  border-radius: 12px !important;
}

.leads-table-card {
  border-radius: 20px !important;
  overflow: hidden;
  background: white;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> tbody tr {
  transition: all 0.2s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
  transform: scale(1.01);
}

.modern-table >>> .v-data-table-header {
  background-color: #fafafa !important;
}

.modern-table >>> .v-data-table-header th {
  font-weight: 700 !important;
  font-size: 14px !important;
  color: #424242 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@media (max-width: 960px) {
  .welcome-header h1 {
    font-size: 28px !important;
  }

  .welcome-header p {
    font-size: 16px !important;
  }

  .stat-card .text-h3 {
    font-size: 32px !important;
  }
}
</style>

